<template>
  <div>
    <search-block :title="'подразделения'">
      <el-row :gutter="10">
        <el-col :span="20">
          <el-input @input="searchUnit" v-model="search"></el-input>
        </el-col>
        <el-col :span="4">
          <el-button @click="showAddModal" type="primary"> Добавить</el-button>
        </el-col>
      </el-row>
    </search-block>
    <el-table stripe border :data="unitList.content">
      <el-table-column label="Наименование">
        <template slot-scope="row">
          {{
            row.row.organizationId +
            "/" +
            row.row.listName[row.row.listName.length - 1].name
          }}
        </template>
      </el-table-column>
      <el-table-column
        label="Номер телефона"
        prop="phoneNumber"
      ></el-table-column>
      <el-table-column label="Период действия">
        <template slot-scope="row">
          <!-- eslint-disable -->
          <p>
            {{  (row.row.dateFrom == null ? "..." : ((new Date(row.row.dateFrom).getDate()<10?'0':'') + new Date(row.row.dateFrom).getDate()+"."+(new Date(row.row.dateFrom).getMonth()<9?'0':'')+(new Date(row.row.dateFrom).getMonth()+1)+"."+new Date(row.row.dateFrom).getFullYear()))+"-"+(row.row.dateTo == null ? "..." : ((new Date(row.row.dateTo).getDate()<10?'0':'')+new Date(row.row.dateTo).getDate()+"."+(new Date(row.row.dateTo).getMonth()<9?'0':'')+(new Date(row.row.dateTo).getMonth()+1)+"."+new Date(row.row.dateTo).getFullYear()))  }}
          </p>
          <!-- eslint-enable -->
        </template>
      </el-table-column>
      <el-table-column label="Адрес">
        <template slot-scope="row">
          <p v-if="row.row.street !== null">Ул. {{ row.row.street }}</p>
          <p v-if="row.row.areaInfo.name !== null">
            Обл. {{ row.row.areaInfo.name }}
          </p>
          <p v-if="row.row.districtInfo.name !== null">
            Р-н {{ row.row.districtInfo.name }}.
          </p>
          <p>{{ row.row.cityInfo.name }}</p>
        </template>
      </el-table-column>
      <el-table-column label="Ответственные">
        <template slot-scope="row">
          <ul>
            <li
              :key="key"
              v-for="(responsible, key) in row.row.responsiblePersonsInfo"
            >
              {{ responsible.name }}
            </li>
          </ul>
        </template>
      </el-table-column>
      <el-table-column label="">
        <template slot-scope="row">
          <el-row :gutter="10">
            <el-col :span="24">
              <el-button
                size="mini"
                style="width: 100%"
                @click="showUpdateModal(row)"
                type="warning"
                >Редактировать</el-button
              >
              <el-button
                @click="deleteBranches(row)"
                size="mini"
                style="width: 100%; margin-left: 0; margin-top: 5px"
                type="danger"
                >Удалить</el-button
              >
            </el-col>
          </el-row>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      style="text-align: center"
      layout="total, sizes, prev, pager, next"
      background
      :page-sizes="[20, 40, 60, 80, 100]"
      :page-size="unitList.size"
      :current-page.sync="unitList.number + 1"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :total="unitList.totalElements"
    >
    </el-pagination>

    <custom-modal title="Добавить филиал" :visible="showModal === 'addBranch'">
      <branches-add></branches-add>
    </custom-modal>

    <custom-modal
      title="Изменить филиал"
      :visible="showModal === 'updateBranch'"
    >
      <branches-edit :selected-branch="selectedBranch"></branches-edit>
    </custom-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CustomModal from "@/components/customModal";
import BranchesAdd from "@/components/ecologist/branches/branchesAdd";
import BranchesEdit from "@/components/ecologist/branches/branchesEdit";
export default {
  name: "branchesTable",
  components: { SearchBlock, BranchesEdit, BranchesAdd, CustomModal },
  data() {
    return {
      search: "",
      selectedBranch: {},
      UNIT_TYPE: 1,
    };
  },
  computed: {
    ...mapGetters({
      unitList: "GETUNITSLIST",
      showModal: "GETSHOWMODAL",
    }),
  },

  methods: {
    searchUnit(query) {
      this.$store.dispatch("searchUnits", {
        unitType: this.UNIT_TYPE,
        page: 0,
        size: 20,
        query: query,
      });
    },

    showAddModal() {
      this.$store.dispatch("setShowModal", "addBranch");
    },

    showUpdateModal(item) {
      this.selectedBranch = item.row;
      if (this.selectedBranch.dateFrom != null)
        this.selectedBranch.dateFrom = new Date(this.selectedBranch.dateFrom);
      if (this.selectedBranch.dateTo != null)
        this.selectedBranch.dateTo = new Date(this.selectedBranch.dateTo);
      this.selectedBranch.listName.forEach((element) => {
        if (element.dateTo != null) element.dateTo = new Date(element.dateTo);
        if (element.dateFrom != null)
          element.dateFrom = new Date(element.dateFrom);
      });
      this.$store.dispatch("getDistrictNames", {
        areaId: this.selectedBranch.areaInfo.id,
        query: this.selectedBranch.districtInfo.name,
      });
      this.$store.dispatch("getCitiesNamesForUser", {
        areaId: this.selectedBranch.areaInfo.id,
        districtId: this.selectedBranch.districtInfo.id,
        query: this.selectedBranch.cityInfo.name,
      });
      this.$store.dispatch("setShowModal", "updateBranch");
    },

    handleSizeChange(val) {
      this.getListUnits({ page: 0, size: val });
    },

    handleCurrentChange(val) {
      this.getListUnits({ page: val - 1, size: this.unitList.size });
    },

    deleteBranches(row) {
      this.confirm(
        "Удалить филиал",
        "Вы действительно хотите удалить филиал",
        "warning",
        "Удалить",
        "Отмена"
      ).then(() => {
        this.$store
          .dispatch("deleteOrganizationUnit", row.row.organizationId)
          .then(() => {
            this.notification("Успешно", "Филиал удален", "success");
            this.getListUnits({
              page: this.unitList.number,
              size: this.unitList.size,
            });
          });
      });
    },

    getListUnits(data) {
      this.$store.dispatch("getListUnits", {
        unitType: this.UNIT_TYPE,
        page: data.page,
        size: data.size,
      });
    },
  },

  mounted() {
    this.getListUnits({ size: 20, page: 0 });
  },
};

import SearchBlock from "@/components/searchBlock";
</script>

<style scoped></style>
